
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.517 1.585a5.414 5.414 0 017.65 0h-.003a5.423 5.423 0 010 7.65L9.98 16.422a5.367 5.367 0 01-3.822 1.58A5.4 5.4 0 012.34 8.764l7.177-7.18zm3.795 9.382l2.795-2.792a3.87 3.87 0 001.138-2.76 3.9 3.9 0 00-6.664-2.77L7.786 5.441a.375.375 0 000 .53l4.996 4.996a.375.375 0 00.53 0z","fill":"currentColor"}})])
          )
        }
      }
    